import axios from "axios";
import { GET_CANNED_RESTRICTIONS_FOR_PROJECT, GET_CONDITIONS_FOR_PROJECT, GET_CUSTOM_RESTRICTIONS_FOR_PROJECT } from "./ActionType";

export const getCannedRestrictionsResult = (projectId, restrictions) => ({
  type: GET_CANNED_RESTRICTIONS_FOR_PROJECT,
  payload: { projectId, restrictions }
});

export const getCustomRestrictionsResult = (projectId, restrictions) => ({
  type: GET_CUSTOM_RESTRICTIONS_FOR_PROJECT,
  payload: { projectId, restrictions }
});

export const getConditionsResult = (projectId, conditions) => ({
  type: GET_CONDITIONS_FOR_PROJECT,
  payload: { projectId, conditions }
});

export function getCannedRestrictionsByProject(projectId) {
  return async function(dispatch, getState) {
    // todo: first check if we already have restrictions for this project in the store
    try {
      const { data } = await axios.get(
        global.REACT_APP_API_ENDPOINT +
        `/delvyRestrictions/all-pre-canned`
      );

      const restrictions = (Array.isArray(data) ? data : [])
        .map((r) => ({
          ...r,
          // Backward-compatible field names used across the app
          restrictionsName: r.restrictionsName ?? r.restrictionName,
          restrictionsDescription: r.restrictionsDescription ?? r.restrictionDescription,
          // Preferred field names for newer components
          restrictionName: r.restrictionName ?? r.restrictionsName,
          restrictionDescription: r.restrictionDescription ?? r.restrictionsDescription,
        }))
        .sort((a, b) => {
          const nameA = (a.restrictionName ?? a.restrictionsName ?? "").toString();
          const nameB = (b.restrictionName ?? b.restrictionsName ?? "").toString();
          return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: "base" });
        });

      dispatch(getCannedRestrictionsResult(projectId, restrictions));
    } catch (err) {
      console.log(err);
    }
  };
}

// async getPreCannedRestriction(passData) {
//     if (isProjectStandardRole()) {
//       try {
//         let id = this.props.match.params.project_id;
//         const { data: formData } = await axios.get(
//           global.REACT_APP_API_ENDPOINT +
//           `/delvyRestrictions/editProjectManualDeliveryRestrictions/` +
//           id
//         );
//         formData.preCannedDR = formData.preCannedDR
//           ?.sort((a, b) => {
//             const item1 = a["restrictionsName"].split(" ")[1];
//             const item2 = b["restrictionsName"].split(" ")[1];
//             return parseInt(item2) < parseInt(item1) ? 1 : -1;
//           })
//           .map((restriction) => restriction);
//         this.setState({
//           formData,
//         });
//       } catch (err) {
//         console.log(err);
//       }
//     }
//   }